import React from "react";
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { Box, Button, Toolbar } from '@mui/material';
import { TextareaAutosize } from '@mui/base';

const ContactForm = () => {


    return (
        <React.Fragment>
            <Box height={"auto"}>
                <Stack direction={{xs:"column",}} spacing={2} sx={{ justifyContent: 'center' }}>
                    <TextField variant="outlined" label="Name" type="text" backgroundColor="#133F49" />
                    <TextField variant="outlined" label="Email" type="email" backgroundColor="#133F49" />
                </Stack>
                <br />
                {/* <TextField variant="outlined" label="Message" type="text" fullWidth sx={{ height: "20vh" }} /> */}
                <TextareaAutosize maxRows={10} style={{ width: "100%", minHeight: '10vh' }} />
                <br /><br />
                <Button variant="contained" sx={{ backgroundColor: "#133F49", ":hover": "#133F49 !important" }}>Submit</Button>
                <br /><br />
            </Box>


        </React.Fragment>
    );
};

export default ContactForm;